<p>product-type-field works!</p>
